import React from "react";

import '../Style.css';

import { IoIosSend } from "react-icons/io";
import { IoCall } from "react-icons/io5";
import { BiRightTopArrowCircle } from "react-icons/bi";

import person_weighing_scale from '../Assets/Images/Economic Scales/Health Scale/Person_weighing_scale.png'
import baby_weighing_scale from '../Assets/Images/Economic Scales/Health Scale/Baby_weighing.png'
import adult_weighing from '../Assets/Images/Economic Scales/Health Scale/adult_weighing.png'


function Healthscale() {
    return (
        <div>


            <section className="py-5">
                <div className="container py-lg-5">
                    <div class="mt-3">
                        <p class="section-top-heading-css py-3 py-lg-0">health Scale</p>

                    </div>
                    <div className="row   row-cols-lg-2 row-cols-1 min-vh-100 justify-content-center g-4 align-items-center ">
                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    Baby weighing scale
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={baby_weighing_scale} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 30 kg</p>
                                            <p className="about-card-para-css">Accuracy : 5 g</p>
                                            {/* <p className="about-card-para-css">Platter Size ( mm ) : 600 x 600</p> */}
                                        </div>

                                        <a href="/Babyweighingscale" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    Adult weighing scale
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={adult_weighing} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 150 kg</p>
                                            <p className="about-card-para-css">Accuracy : 100 g</p>

                                        </div>

                                        <a href="/Adultweighingscale" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <div className="col  text-center">
                            <div className=" card about-small-card-css h-100 p-3">
                                <p className="about-card-heading-css text-center">
                                    Person weighing scale
                                </p>
                                <div className="row row-cols-2 ">
                                    <div className="col">
                                        <div className="text-center image-stretch-css">
                                            <img className="product-swiper-image-sample" src={person_weighing_scale} />
                                        </div>
                                    </div>
                                    <div className="col text-start">
                                        <div>
                                            <p className="about-card-para-css">Capacity : 150 kg</p>
                                            <p className="about-card-para-css">Accuracy : 100 g</p>
                                            {/* <p className="about-card-para-css">Platter Size ( mm ) : 600 x 600</p> */}
                                        </div>

                                        <a href="/Personweighingscale" className="text-start about-card-para-css" >
                                            <button className="btn about-card-para-css px-0">
                                                <span className="underline_text ">Know More</span><BiRightTopArrowCircle className="ms-1 button-icon-css" />
                                            </button>
                                        </a>

                                    </div>
                                </div>
                                <div className="row row-cols-lg-2 row-cols-2 justify-content-center g-3 text-center">
                                    <div className="col">
                                        <a href="https://wa.me/919443030062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2">Get Price <IoIosSend className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>
                                    <div className="col">
                                        <a href="tel:+91 94430 30062" target="_blank" className="" >
                                            <button className="btn CTA-button-css-2 ">Call Now <IoCall className="ms-2 button-icon-css" />
                                            </button>
                                        </a>
                                    </div>

                                </div>

                            </div>
                        </div>


                    </div>
                </div>
            </section>


        </div >

    );
}

export default Healthscale;
